<template>
    <van-dialog
        v-model="show"
        :title="allowanceInfo.title"
        :confirmButtonText="allowanceInfo.button"
        confirmButtonColor="#333333"
    >
        <div class="allowance-dialog">
            <ul class="descs">
                <li v-for="(tip, index) in allowanceInfo.content" :key="index">{{ tip }}</li>
            </ul>
            <img class="guide" :src="allowanceInfo.picUrl" alt />
        </div>
    </van-dialog>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'vant';
import { request } from 'root/common/request';
import config from 'root/common/config/config';
const allowanceDialog = `${config.fanxianDomain}/api/dictionary/bykey`; // key=BWBT_ALLOWANCE_EXPLAIN

Vue.use(Dialog);

export default {
    props: ['value'],
    data() {
        return {
            show: false,
            allowanceInfo: {},
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.show = newVal;
            },
        },
        show(newVal) {
            this.$emit('input', newVal);
        },
    },
    async mounted() {
        const result = await this.getAllowanceDialog({ key: 'BWBT_ALLOWANCE_EXPLAIN' });
        if (result.code == 200) {
            const allowanceInfo = result?.data ? JSON.parse(result.data) : { content: '' };
            this.allowanceInfo = {
                ...allowanceInfo,
                content: allowanceInfo.content.split('<br />'),
            };
        }
    },
    methods: {
        getAllowanceDialog(params, options) {
            return request({
                url: allowanceDialog,
                method: 'GET',
                params,
                isNeedLoading: false,
                isNeedToken: false,
                ...options,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.allowance-dialog {
    padding: 0.3rem;
    .descs {
        li {
            text-align: justify;
            max-width: 5.7rem;
            font-size: 0.28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 0.42rem;

            &:nth-child(n + 2) {
                margin-top: 0.06rem;
            }
        }
    }
    .guide {
        margin-top: 0.2rem;
        width: 5.7rem + 0.18rem + 0.29rem;
        transform: translate(-0.29rem, -0.18rem);
        height: 3.37rem + 0.29rem;
        flex-shrink: 0;
        // box-shadow: 0 0 0.08rem 0 rgba(0, 0, 0, 0.16);
        // border: 1px solid #ffa663;
    }
}
</style>
